import React, { useContext } from 'react';
import { Box, Autocomplete, TextField, Popper } from "@mui/material";
import { MyDialog } from "../../component/index";
import DataSourceContext from "../../context/DataSourceMngContext";
import { ContentsOnedrive } from "../data-source/onedrive/create";

export default function DialogCreateServer() {

  const { dialog, loading, selectServer } = useContext(DataSourceContext);

  return (
    <MyDialog
      Header={`Setup ${selectServer?.display_name || ''}`}
      textConfirm="Save"
      maxHeight={600}
      minWidth={500}
      open={dialog.add_server}
      loading={loading?.modal}
      actionContent={false}>
      {DateContent()}
      {Contents(selectServer?.name || selectServer?.display)}
    </MyDialog>
  );
}

function Contents(status) {
  switch (status) {
    case 'api':
      return null;
    case 'sat':
      return null;
    case 'iot':
      return null;
    case 'database':
      return null;
    case 'huawei':
      return null;
    case 'One Drive':
    case 'onedrive':
      return <ContentsOnedrive />;
    case 'google_drive':
      return null;
    default:
      break;
  }
}

function DateContent() {
  const endYear = new Date().getFullYear().toString(); // Convert to string

  // Generate an array of years as strings
  const { years, select_year, fetchYears, setDataState, fetchConfigure } = useContext(DataSourceContext);

  const handleSelectDate = (event, newValue) => {
    setDataState((prevState) => ({
      ...prevState,
      select_year: newValue
    }));
    fetchConfigure(newValue);
  }

  return (
    <Box
      sx={{ position: 'absolute', top: 0, left: 0, padding: '15px 15px', width: '100%', display: 'flex', justifyContent: 'end' }}
    >
      <Box sx={{ width: '27%' }}>
        <Autocomplete
          options={years}
          defaultValue={select_year}
          getOptionLabel={(option) => option?.cycle}
          size="small"
          onFocus={() => fetchYears()}
          onChange={handleSelectDate}
          renderInput={(params) => <TextField {...params} />}
        />
      </Box>
    </Box>
  );
}